<template>
  <UiWrapper
    :name="name"
    :label="label"
    :validations="validations"
    :optional="optional"
  >
    <IntegerWrapper />
  </UiWrapper>
</template>


<script>
import UiWrapper from '@/forms/components/base/ui-wrapper';
import IntegerWrapper from '@/forms/components/ui-dunia/integer-wrapper';
import * as conditions from '@/forms/conditions';
import {
  MAX_ALLOWED,
  MIN_ALLOWED,
} from '@/forms/constants/onboarding-logic';

export default {
  name: 'FieldsetVariableIncome',

  components: {
    UiWrapper,
    IntegerWrapper,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    optional: {
      type: Boolean,
      default: false,
    },
    validations: {
      type: Array,
      default: () => ([
       
        {
          errorMessage: `The amount can not be higher than ${MAX_ALLOWED}`,
          condition: conditions.lteCondition(MAX_ALLOWED),
          name: 'is-under-max-allowed-amount',
        },
      ]),
    },
  },
};
</script>
